import { Modal } from 'react-bootstrap';
import i18next from 'i18next';
import { useApiClient } from '../../../hooks/useApiClient';
import AccountForm from '../../AccountForm/AccountForm';
import OpportunityCreation from '../OpportunityCreation/OpportunityCreation';
import useLeadsStore from '../../../store/LeadsStore';
import { ClienteEnum } from '../../../api/models/Enums';

interface OpportunityModalsProps {
  validation?: any;
  modalType?: string;
  setAccountSearchOpt: any;
  setAccountModalOpened?: any;
  funnelData?: any;
  setFunnelData?: React.Dispatch<React.SetStateAction<any>>;
  show?: boolean;
  onHide?: () => void;
  account?: any;
  setOpportunityValues?: React.Dispatch<React.SetStateAction<any>>;
  opportunityValues?: any;
  opportunityFields?: any[];
  accountInitialValues?: any;
  opportunityValidationSchema?: any;
}

const OpportunityModals = ({
  modalType,
  setAccountSearchOpt,
  setAccountModalOpened,
  setFunnelData,
  funnelData,
  show,
  onHide,
  account,
  setOpportunityValues,
  opportunityValues,
  opportunityFields,
  accountInitialValues
}: OpportunityModalsProps) => {

  const { apiClient, handleApiResponse } = useApiClient();
  const { setLeadWizardData, activeLead } = useLeadsStore()

  const getModalHeader = () => {
    switch (modalType) {
      case 'account':
        return i18next.t('create_new_account');
      case 'opportunity':
        return i18next.t('create_opportunity');
      default:
        return i18next.t('error_unrecognized_operation');
    }
  };

  const getModalBody = () => {
    let initialValues;
    let mode;
    if (modalType === 'account') {
      mode = 'create';
      initialValues = Object.assign({
        Codice_Fiscale__c: '',
        Name: activeLead?.Cliente__c === ClienteEnum.Azienda ? activeLead?.Company : "",
        RecordTypeId: '',
        Email__c: '',
        Phone: '',
        Partita_IVA__c: '',
        reference_partner: '',
        CreatedDate: '',
        BillingCity: '',
        BillingStreet: '',
        Flotta_Potenziale_PC__c: null,
        Flotta_Potenziale_LCV__c: null,
        Flotta_Totale_PC__c: null,
        Flotta_Totale_LCV__c: null,
      }, accountInitialValues || {});
    }

    if (modalType === 'opportunity') {
      mode = 'create';
    }

    switch (modalType) {
      case 'account':
        return (
          <AccountForm
            mode={mode}
            initialValues={initialValues}
            pickPersistent={true}
            afterSubmitFn={(id) => {
              setAccountSearchOpt(null);
              setAccountModalOpened(false);

              handleApiResponse(apiClient.salesforceAccountController.getAccount(id))
                .then(res => {
                  setFunnelData?.({ ...funnelData, account: res.data[0] });
                  setLeadWizardData({ account: res.data[0] });
                });
            }}
          />
        );
      case 'opportunity':
        return (
          <OpportunityCreation
            account={account}
            setOpportunityValues={setOpportunityValues}
            opportunityValues={opportunityValues}
            opportunityFields={opportunityFields}
            onHide={onHide}
          />
        )
      default:
        return null;
    }
  };


  return (
    <Modal show={show} onHide={onHide} size='lg'>
      <Modal.Header closeButton>
        <Modal.Title>{getModalHeader()}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          {getModalBody()}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default OpportunityModals;
